// Experiment:
// https://ab.daylight.stitchfix.com/expts/1792
export const frontDoorOfferExp = {
  expectedValues: ['no_promo', 'standard', 'percentage'],
  fallbackValue: 'standard',
  name: 'fy27-q1-fd-offer-experiment'
};

// Experiment:
// https://ab.daylight.stitchfix.com/expts/1693
export const supFixTwentyVsThirtyExp = {
  expectedValues: ['twenty', 'thirty'],
  fallbackValue: 'twenty',
  name: 'eng.incentives.sup_fix_30_vs_20_feb2026'
};